/**
 * Service worker + PWA install-prompt manager.
 *
 * - Registers /service-worker.js on load.
 * - Captures `beforeinstallprompt` and exposes it via `window.sbDeferredPrompt`
 *   + a custom `sb:pwa-installable` event so any React component (e.g. the
 *   admin header) can render an "Install app" button and call
 *   `window.sbDeferredPrompt.prompt()`.
 * - Fires `sb:pwa-installed` on successful install.
 *
 * Only wires itself up on production-safe origins (HTTPS or localhost). The
 * dev container is HTTPS by default so this works in preview too.
 */

const isSecureContext =
  typeof window !== "undefined" &&
  (window.location.protocol === "https:" || window.location.hostname === "localhost");

export function registerPWA() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator) || !isSecureContext) return;

  // Register on load so we don't compete with the main bundle for parse time.
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch(() => {
        /* Silent — SW is progressive enhancement, never a hard requirement. */
      });
  });

  // Capture the Chrome/Edge/Android install prompt so we can trigger it later
  // from an in-app button rather than the default mini-infobar.
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.sbDeferredPrompt = e;
    window.dispatchEvent(new CustomEvent("sb:pwa-installable"));
  });

  window.addEventListener("appinstalled", () => {
    window.sbDeferredPrompt = null;
    window.dispatchEvent(new CustomEvent("sb:pwa-installed"));
  });
}
